import $ from 'jquery';
import Flickity from 'flickity';
import FLICKITY_ARROW_ICON from '../assets/flickityArrowIcon';

export default class StaticLookbook {
  constructor(section) {
    this.el = section.el;
    this.$body = $(document.body);
    this.$window = $(window);

    this.slideShowSelector = '[data-lookbook-slider]';
    this.slideShowsEls = this.el.querySelectorAll(this.slideShowSelector);
    this.slideshows = [];
    this.$slideShows = $(this.slideShowSelector, this.el);

    if (this.$slideShows) {
      this._initSlideShows();
    }
  }

  onSectionUnload() {
    this.slideshows.forEach((slideShow) => {
      slideShow.destroy();
    });
  }

  _initSlideShows() {
    // arrowShape is drawn on a 100x100 ViewBox, only need the left arrow
    const arrowShape = FLICKITY_ARROW_ICON;

    const flickityOptions = {
      autoPlay: 0,
      adaptiveHeight: true,
      cellSelector: '.lookbook-slide',
      cellAlign: 'center',
      pageDots: false,
      prevNextButtons: true,
      wrapAround: true,
      arrowShape,
    };

    for (let i = 0; i < this.slideShowsEls.length; i += 1) {
      const slideShow = new Flickity(this.slideShowsEls[i], flickityOptions);
      slideShow.resize();
      this.slideshows.push(slideShow);
    }
  }
}
